module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete_page_confirmation":"Are you sure you want to delete this page? This page will be deleted permanently."},"id":{"delete_page_confirmation":"Anda yakin ingin menghapus halaman ini? Halaman ini akan dihapus secara permanen."}}')
  delete Component.options._Ctor
}
